/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGiveawayBudgetForCurrentTimePeriodResponse } from '../../models/get-giveaway-budget-for-current-time-period-response';

export interface CommunityServerServiceGetGiveawayBudgetForCurrentTimePeriod$Params {
}

export function communityServerServiceGetGiveawayBudgetForCurrentTimePeriod(http: HttpClient, rootUrl: string, params?: CommunityServerServiceGetGiveawayBudgetForCurrentTimePeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGiveawayBudgetForCurrentTimePeriodResponse>> {
  const rb = new RequestBuilder(rootUrl, communityServerServiceGetGiveawayBudgetForCurrentTimePeriod.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGiveawayBudgetForCurrentTimePeriodResponse>;
    })
  );
}

communityServerServiceGetGiveawayBudgetForCurrentTimePeriod.PATH = '/api/v3/gateway/communityserver/giveaway/budget';
